import {
  FETCH_LINK_BY_TOKEN,
  FETCH_LINK_BY_TOKEN_SUCCESS,
  FETCH_LINK_BY_TOKEN_FAILURE,
  RESET_FETCH_LINK_BY_TOKEN,
  VALIDATE_LINK_BY_TOKEN,
  VALIDATE_LINK_BY_TOKEN_SUCCESS,
  VALIDATE_LINK_BY_TOKEN_FAILURE,
  CREATE_LINK,
  CREATE_LINK_SUCCESS,
  CREATE_LINK_FAILURE,
} from "./actionTypes";

export const fetchLinkByToken = (linkRequest, navigate, type = "private") => {
  return {
    type: FETCH_LINK_BY_TOKEN,
    payload: { linkRequest, navigate, type },
  };
};

export const fetchLinkByTokenSuccess = (linkData) => {
  return {
    type: FETCH_LINK_BY_TOKEN_SUCCESS,
    payload: linkData,
  };
};

export const fetchLinkByTokenFailure = (error) => {
  return {
    type: FETCH_LINK_BY_TOKEN_FAILURE,
    payload: error,
  };
};

export const resetFetchLinkByToken = () => {
  return {
    type: RESET_FETCH_LINK_BY_TOKEN,
  };
};

export const validateLinkByToken = (linkRequest, navigate, setPageLoading) => {
  return {
    type: VALIDATE_LINK_BY_TOKEN,
    payload: { linkRequest, navigate, setPageLoading },
  };
};

export const validateLinkByTokenSuccess = (linkData) => {
  return {
    type: VALIDATE_LINK_BY_TOKEN_SUCCESS,
    payload: linkData,
  };
};

export const validateLinkByTokenFailure = (error) => {
  return {
    type: VALIDATE_LINK_BY_TOKEN_FAILURE,
    payload: error,
  };
};

export const createLink = (linkRequest, setGeneratedLink) => {
  return {
    type: CREATE_LINK,
    payload: { linkRequest, setGeneratedLink },
  };
}

export const createLinkSuccess = (linkData) => {
  return {
    type: CREATE_LINK_SUCCESS,
    payload: linkData,
  };
}

export const createLinkFailure = (error) => {
  return {
    type: CREATE_LINK_FAILURE,
    payload: error,
  };
}

